module.exports = __webpack_public_path__ + "img/collection-weddingRingsStarrySky@2x.7e6caa8.webp";